const headers = [ 
  {
    label: 'วันที่เข้าใช้งาน',
    field: 'createDateStr',
  },
  {
    label: 'Ip',
    field: 'device',
  },
  {
    label: "ผู้ใช้งาน",
    field: "fullname",
  },
  {
    label: "Action",
    field: "UserAction",
  },
  {
    label: "URL",
    field: "url",
  },
  {
    label: "ข้อผิดพลาด",
    field: "exception",
  },
];

export default headers;
